/**
 * Single place for the active NCOB Stripe key. Initialized from config/index;
 * set from salon country when salon details are loaded (see middleware/stripeSalonKey.js).
 * Use getNcobStripeKey() everywhere instead of NCOB_STRIPE_KEY / NCOB_STRIPE_KEY_US.
 */

let defaultKey = '';
let usKey = '';
let currentKey = '';

export function initNcobStripeKeys(defaultK, usK) {
  defaultKey = defaultK;
  usKey = usK;
  currentKey = defaultK;
}

export function setNcobStripeKeyForCountry(countryCode) {
  if (defaultKey && usKey) {
    currentKey = countryCode === 'US' ? usKey : defaultKey;
  }
}

export function getNcobStripeKey() {
  return currentKey || defaultKey;
}
